export const EMPTY_OPTION_VALUE = Symbol('ng-select empty option value');
